export default "__VITE_ASSET__DtmAbeF5__"